// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_9e1425b4d3--wrapper--lDoJg","list-wrapper":"_9e1425b4d3--list-wrapper--GMVsa","item-wrapper":"_9e1425b4d3--item-wrapper--TB1Rf","link":"_9e1425b4d3--link--rwijo"};